import { isNil } from 'lodash';

export default {
  isUserLoggedIn: (state: { user: any }) => !isNil(state.user),
  getDropdown: (state: { mainOptions: { [x: string]: { options: any } }; dropdownIndex: string | number }) => {
    console.log(state.mainOptions[state.dropdownIndex]);
    return state.mainOptions[state.dropdownIndex].options;
  },
  getOptions: (state: { mainOptions: any }) => state.mainOptions,
  getSelectedOption: (state: { dropdownMainSelected: any }) => state.dropdownMainSelected,
};
